<nz-upload
  [nzShowButton]="!readonly"
  [(nzFileList)]="files"
  [nzFileListRender]="filesTemplate"
  [nzCustomRequest]="upload"
  [nzBeforeUpload]="beforeUpload"
  [nzAccept]="mimeTypes"
  [nzFileType]="mimeTypes"
  [nzMultiple]="true"
  (nzChange)="onChange($event)"
>
  <div class="app-file-upload">
    <app-image name="attach-circle" display="inline"></app-image>
    <span translate>fileUpload.attach</span>
  </div>
</nz-upload>

<ng-template #filesTemplate let-files>
  <ul class="app-file-list">
    @for (file of files; track file) {
    <li class="app-file app-file-{{ file.status.toString() }}" (click)="download(file)">
      <div class="app-file-icon">
        <app-image [name]="file.name | fileIcon"></app-image>
      </div>
      <div class="app-file-name">{{ file.name }}</div>
      <div class="app-file-size">{{ file.size | fileSize }}</div>
      @if (!readonly) {
      <div class="app-file-close">
        <app-image name="close" (click)="delete($event, file)"></app-image>
      </div>
      }
      <div class="app-file-progress">
        <div class="app-file-progress-percent" [style.width]="file.percent + '%'"></div>
        @if (file.status === 'error') {
        <div class="app-file-progress-message">{{ file.error | errorMessage }}</div>
        }
      </div>
    </li>
    }
  </ul>
</ng-template>
